import { useNavigate } from 'react-router';

import styles from '../styles/Index.module.css';

export default function Index() {
    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className={styles.mainPanel}>
                <h2>Личный кабинет арбитражных управляющих<br/>Союза «СОАУ «Альянс»</h2>
                <p>Отслеживайте процедуры, управляйте заявками и взаимодействуйте с СРО — всё в одном удобном интерфейсе.</p>
            </div>

            <span className={styles.outlinePanelWHeadlineWrapper}>
                <h2 className={styles.headlineWithPaddings}>Обратите внимание</h2>
                <div className={styles.outlinePanel}>
                    <span className={styles.horizontalContainer}>
                        <p>Доступ к системе Личного кабинета имеют только арбитражные управляющие и сотрудники аппарата Союза «СОАУ «Альянс». Помощники управляющих и иные лица, не состоящие в реестре Союза, доступ к ЛК получить не смогут.</p>
                    </span>
                </div>
            </span>
            <span className={styles.outlinePanelWHeadlineWrapper}>
                <h2 className={styles.headlineWithPaddings}>Полезные материалы</h2>
                <div className={styles.outlinePanel}>
                    <span className={styles.horizontalContainer}>
                        <p>Просмотрите инструкцию использования ЛK</p>
                        <p className='aWithLink' onClick={() => navigate('/help')}>Открыть</p>
                    </span>
                </div>
                <div className={styles.outlinePanel}>
                    <span className={styles.horizontalContainer}>
                        <p>Ознакомьтесь с важной информацией по безопасному взаимодействию с СРО</p>
                        <p className='aWithLink' onClick={() => navigate('/help#safety')}>Открыть</p>
                    </span>
                </div>
                <div className={styles.outlinePanel}>
                    <span className={styles.horizontalContainer}>
                        <p>Страница проверки подлинности письма от СРО</p>
                        <p className='aWithLink' onClick={() => navigate('/safety/email-authentication')}>Открыть</p>
                    </span>
                </div>
            </span>

            <span className={`${styles.outlinePanelWHeadlineWrapper} ${styles.additionalPanelWithHeaderLinks}`}>
                <h2 className={styles.headlineWithPaddings}>Войдите в систему</h2>
                <div className={styles.outlinePanel}>
                    <button
                        className='button maxWidth'
                        onClick={() => navigate('/auth/login')}
                    >
                        Войти в учетную запись
                    </button>
                    <button
                        className='button maxWidth'
                        onClick={() => navigate('/auth/registration')}
                    >
                        Зарегистрировать новую учетную запись
                    </button>
                    <button
                        className='button maxWidth'
                        onClick={() => navigate('/send-feedback')}
                    >
                        Обратиться в поддержку
                    </button>
                </div>
            </span>

            <div style={{height: '40px'}}></div>

            <div 
                className={styles.bottomPanel}
                style={{ gridTemplateColumns: '25fr 25fr 25fr 25fr' }}
            >
                <div className={styles.cell}>
                    <p>Личный кабинет Альянс - сервис для управления арбитражными делами, включая обработку документов, отслеживание статусов, взаимодействие с СРО и ведение отчетности</p>
                    <p>© {currentYear || ''} СОАУ «Альянс»</p>
                </div>
                <div className={styles.cell}>
                    <p>По вопросам изменения или удаления данных из системы: <a href='mailto:info@alians009.ru'>info@alians009.ru</a></p>
                    <p>По юридическим вопросам: <a href='mailto:legal@alians009.ru'>legal@alians009.ru</a></p>
                </div>
                <div className={styles.cell}>
                    <p className='aWithLink' onClick={() => navigate('/help')}>Справка</p>
                    <p className='aWithLink' onClick={() => navigate('/safety/email-authentication')}>Страница проверки подлинности адреса электронной почты из письма</p>
                    <p className='aWithLink' onClick={() => navigate('/legal/terms-of-use')}>Условия использования</p>
                    <p className='aWithLink' onClick={() => navigate('/legal/privacy-policy')}>Пользовательское соглашение</p>
                </div>
                <div className={styles.cell}>
                    <p className='aWithLink' onClick={() => navigate('/auth/login')}>Войти в учётную запись</p>
                    <p className='aWithLink' onClick={() => navigate('/auth/registration')}>Зарегистрировать новую учётную запись</p>
                </div>
            </div>
        </>
    )
}
